import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { XIGUA_LANGUAGE } from '@src/utils/locale';
import DateUtil from '@src/utils/date-util';
import responseMessage from "@src/services/json/zt/responseMessage";

/**
 *
 * @param request {Json}
 * @param reject
 * @param rootAddress
 * @return {{
 *   getAccountState
 * }}
 */
export default function(request, reject, rootAddress) {
  var lang = getLanguageByPath();

  var service = {};
  var defaultCommonParams = {
    language: XIGUA_LANGUAGE[lang]
  };

  /**
   * 获取信号状态
   * @param uid
   * @param bind_type
   * @return {Promise<*>}
   */
  service.getAccountState = function({ uid, bind_type }) {
    return request
      .get(rootAddress + '/webapp/official/get_account_state', {
        uid,
        bind_type
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          return response.data;
        }

        return reject(responseMessage(response, 'zt'));
      });
  };

  /**
   * 登录（用在注销后重新激活的情况下）
   * @param email
   * @param password
   * @return {Promise<*>}
   */
  service.loginForActive = function({ email, password, ...params }) {
    return request
      .post(rootAddress + '/webapp/official/login_for_activate', {
        email,
        password,
        ...params
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 申请注销
   * @param token
   * @param code
   * @return {Promise<*>}
   */
  service.applyCancelPassport = function({ token, code, login_type, open_id }) {
    return request
      .post(rootAddress + '/webapp/official/apply_cancel_passport', {
        token,
        code,
        login_type,
        open_id
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 重新激活注销中的账号
   * @param open_id
   * @return {Promise<*>}
   */
  service.stopCancelPassport = function({ open_id }) {
    return request
      .post(rootAddress + '/webapp/official/stop_cancel_passport', {
        open_id
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 登录第三方接口
   * @param type
   * @param callbackUrl
   * @return {Promise<*>}
   */
  service.loginByThirdLogin = function({ type, callbackUrl }) {
    return request
      .get(rootAddress + `/webapp/official/proxy?uri=seasun/login/social/${type}`, {
        callbackUrl,
        ...defaultCommonParams
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 关联第三方
   * @param type
   * @param callbackUrl
   * @param token
   * @return {Promise<*>}
   */
  service.bindAccountByThirdParty = function({ type, callbackUrl, token }) {
    return request
      .get(rootAddress + `/webapp/official/proxy?uri=seasun/login/social/bind/${type}`, {
        callbackUrl,
        ...defaultCommonParams,
        token
      })
      .then(response => {
        if (response.status === 1 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  service.getConfigData = null;

  /**
   * 获取配置
   * @param open_id
   * @return {Promise<*>}
   */
  service.getConfig = function({ commonParams }) {
    if (service.getConfigData) {
      return Promise.resolve(service.getConfigData);
    }
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/config', {
        ...defaultCommonParams,
        ...commonParams
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          service.getConfigData = response.data;
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 登录接口
   * @param commonParams
   * @param thirdPartyType
   * @param thirdPartyUid
   * @param accessToken
   * @param idToken
   * @param email
   * @param password
   * @param ext
   * @return {Promise<*>}
   */
  service.login = function({ commonParams, thirdPartyType, thirdPartyUid, accessToken, idToken, email, password, ext }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/login', {
        ...defaultCommonParams,
        ...commonParams,
        thirdPartyType,
        thirdPartyUid,
        accessToken,
        idToken,
        email,
        password,
        ext
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 自动登录接口
   * @param commonParams
   * @param token
   * @param uid
   * @return {Promise<*>}
   */
  service.loginByToken = function({ commonParams, token, uid }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/loginByToken', {
        ...defaultCommonParams,
        ...commonParams,
        token,
        uid
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 绑定接口
   * @param commonParams
   * @param uid
   * @param token
   * @param thirdPartyType
   * @param loginType
   * @param thirdPartyUid
   * @param accessToken
   * @param idToken
   * @param ext
   * @return {Promise<*>}
   */
  service.bind = function({ commonParams, uid, token, thirdPartyType, loginType, thirdPartyUid, accessToken, idToken, ext }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/bind', {
        ...defaultCommonParams,
        ...commonParams,
        token,
        uid,
        thirdPartyType,
        loginType,
        thirdPartyUid,
        accessToken,
        idToken,
        ext
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 解绑第三方接口
   * @param commonParams
   * @param uid
   * @param token
   * @param thirdPartyType
   * @return {Promise<*>}
   */
  service.unbindAccountByThirdParty = function({ commonParams, uid, token, thirdPartyType }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/unbind', {
        ...defaultCommonParams,
        ...commonParams,
        token,
        uid,
        thirdPartyType
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 发送邮箱验证码
   * @param commonParams
   * @param email
   * @param type
   * @param ext
   * @return {Promise<*>}
   */
  service.sendCaptcha = function({ commonParams, email, type, ext }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/sendCaptcha', {
        ...defaultCommonParams,
        ...commonParams,
        email,
        type,
        ext
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 验证邮箱验证码
   * @param commonParams
   * @param email
   * @param type
   * @param captcha
   * @return {Promise<*>}
   */
  service.verifyCaptcha = function({ commonParams, email, type, captcha }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/verifyCaptcha', {
        ...defaultCommonParams,
        ...commonParams,
        email,
        type,
        captcha
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 邮箱注册
   * @param commonParams
   * @param email
   * @param password
   * @param captcha
   * @return {Promise<*>}
   */
  service.register = function({ commonParams, email, password, captcha }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/register', {
        ...defaultCommonParams,
        ...commonParams,
        email,
        password,
        captcha
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 修改邮箱
   * @param commonParams
   * @param token
   * @param newEmail
   * @param captcha
   * @return {Promise<*>}
   */
  service.modifyEmail = function({ commonParams, token, newEmail, captcha }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/modifyEmail', {
        ...defaultCommonParams,
        ...commonParams,
        token,
        newEmail,
        captcha
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 绑定邮箱
   * @param commonParams
   * @param token
   * @param email
   * @param password
   * @param captcha
   * @return {Promise<*>}
   */
  service.bindEmail = function({ commonParams, token, email, password, captcha }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/bindEmail', {
        ...defaultCommonParams,
        ...commonParams,
        token,
        email,
        password,
        captcha
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 忘记密码
   * @param commonParams
   * @param newPassword
   * @param email
   * @param captcha
   * @return {Promise<*>}
   */
  service.forgotPassword = function({ commonParams, newPassword, email, captcha }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/forgotPassword', {
        ...defaultCommonParams,
        ...commonParams,
        email,
        newPassword,
        captcha
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 修改密码
   * @param commonParams
   * @param token
   * @param email
   * @param newPassword
   * @param password
   * @return {Promise<*>}
   */
  service.changePassword = function({ commonParams, token, email, newPassword, password }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/changePassword', {
        ...defaultCommonParams,
        ...commonParams,
        token,
        email,
        newPassword,
        password
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 获取注销地址
   * @param commonParams
   * @param token
   * @param passportId
   * @return {Promise<*>}
   */
  service.getDeleteAccountUrl = function({ commonParams, token, passportId }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/getDeleteAccountUrl', {
        ...defaultCommonParams,
        ...commonParams,
        token,
        passportId
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 第三方网页登录
   * @param thirdPartyType
   * @param appId
   * @param callbackUrl
   * @param sign
   * @param ext
   * @return {Promise<*>}
   */
  service.extReceivedAccountNotify = function({ thirdPartyType, appId, callbackUrl, sign, ext }) {
    return request
      .post(rootAddress + `/webapp/official/proxy?uri=seasun/login/${thirdPartyType}`, {
        thirdPartyType,
        appId,
        callbackUrl,
        sign,
        ext
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 外部-注销账号通知
   * @param ksOpenId
   * @param notifyType
   * @param ts
   * @param sign
   * @return {Promise<*>}
   */
  service.extReceivedAccountNotify = function({ ksOpenId, notifyType, ts, sign }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/ext/receivedAccountNotify', {
        ksOpenId,
        notifyType,
        ts,
        sign
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 获取账号信息
   * @param commonParams
   * @param token
   * @return {Promise<*>}
   */
  service.getAccountInfo = function({ commonParams = {}, token }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/getAccountInfo', {
        ...defaultCommonParams,
        ...commonParams,
        token
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 退出游戏或退出当前账号
   * @param commonParams
   * @param token
   * @return {Promise<*>}
   */
  service.logout = function({ commonParams = {}, token }) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/logout', {
        ...defaultCommonParams,
        ...commonParams,
        token
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  service.createOrder = function(params) {
    const { channelId: channel, xgAppId: gameId } = params;
    return (
      request
        // .get(rootAddress + `/webapp/official/proxy?uri=/seasun/createOrder/${channel}/${gameId}`, {
        .post(rootAddress + '/webapp/official/proxy?uri=/seasun/createOrder', {
          ...defaultCommonParams,
          ...params
        })
        .then(response => {
          if (response.code === 0 /* 成功 */) {
            return response.data;
          }

          return reject(response);
        })
    );
  };

  service.queryOrderStatus = function(params) {
    return (
      request
        // .get(rootAddress + `/webapp/official/proxy?uri=/pay/query-order-status/${gameId}`, {
        .post(rootAddress + '/webapp/official/proxy?uri=/seasun/queryOrderStatus', {
          ...defaultCommonParams,
          ...params
        })
        .then(response => {
          if (response.code === 0 /* 成功 */) {
            return response.data;
          }

          return reject(response);
        })
    );
  };

  service.getAppInfos = function(params) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/getAppInfos', {
        ...defaultCommonParams,
        ...params
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  service.getServerInfos = function(gameId) {
    return request
      .post(rootAddress + '/webapp/official/xgsdk_proxy?uri=getServerInfos', {
        ...defaultCommonParams,
        xgAppId: gameId,
        ts: DateUtil.formatDate(new Date(), 'yyyyMMddhhmmss')
      })
      .then(response => {
        if (response.code === '0' /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  service.getRoleInfo = function(params) {
    return request
      .post(rootAddress + '/webapp/official/xgsdk_proxy?uri=getRoleInfo', {
        ...defaultCommonParams,
        ...params,
        ts: DateUtil.formatDate(new Date(), 'yyyyMMddhhmmss')
      })
      .then(response => {
        if (response.code === '0' /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  service.getProductIdInfos = function(params) {
    return request
      .post(rootAddress + '/webapp/official/xgsdk_proxy?uri=getProductIdInfos', {
        ...defaultCommonParams,
        ...params,
        ts: DateUtil.formatDate(new Date(), 'yyyyMMddhhmmss')
      })
      .then(response => {
        if (response.code === '0' /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  service.recordBirth = function(params) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/recordBirth', {
        ...defaultCommonParams,
        ...params
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 获取地区国家
   * @return {Promise<*>}
   */
  service.getIpArea = function() {
    return request.post(rootAddress + '/webapp/official/proxy?uri=seasun/ext/getIpArea', {}).then(response => {
      if (response.code === 0 /* 成功 */) {
        return response.data;
      }

      return reject(response);
    });
  };

  service.queryOrders = function(params) {
    return request
      .post(rootAddress + '/webapp/official/proxy?uri=seasun/queryOrders', {
        ...defaultCommonParams,
        ...params,
        ts: DateUtil.formatDate(new Date(), 'yyyyMMddhhmmss')
      })
      .then(response => {
        if (response.code === 0 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 设置登录信息进cookie
   * @param token
   * @return {Promise<*>}
   */
  service.setLoginInfo = function({ token }) {
    return request
      .post(rootAddress + '/webapp/official/set_login_info', {
        token
      })
      .then(response => {
        if (response.code === 1 /* 成功 */) {
          return response.data;
        }

        return reject(response);
      });
  };

  /**
   * 清空登录cookie信息
   * @return {Promise<*>}
   * @constructor
   */
  service.logoutWithCookie = function() {
    return request.post(rootAddress + '/webapp/official/logout', {}).then(response => {
      if (response.code === 1 /* 成功 */) {
        return response.data;
      }

      return reject(response);
    });
  };

  return service;
}
